import React from 'react';
import { Grid, Autocomplete, TextField, Box, InputAdornment, CircularProgress } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

const BuscadorInsumo = ({
    insumos,
    input,
    idInsumo,
    nombreInsumoSelected,
    filterStatus,
    setFilterStatus,
    handleSelectInsumo,
    insumosLoading,
}) => (
    <Autocomplete
        options={insumos}
        disabled={input.disabled}
        value={insumos?.find(i => i.id === idInsumo)?.label || null}
        disableClearable
        noOptionsText={filterStatus ? 'No hay coincidencias' : 'Escriba para buscar'}
        onChange={(_, newValue) => handleSelectInsumo(newValue)}
        renderOption={(props, option) => (
            <Box {...props} key={option.id}>
                {option?.label}
            </Box>
        )}
        renderInput={(params) => (
            <TextField
                {...params}
                onChange={e => setFilterStatus(e.target.value)}
                sx={{ '.MuiOutlinedInput-root': { paddingRight: '15px !important' } }}
                label={`${input.displayName}${input.required ? '*' : ''}`}
                margin='none'
                size='small'
                inputProps={{
                    ...params.inputProps,
                    value: (!!idInsumo || !!filterStatus) ? params.inputProps.value : ''
                }}
                InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                        <InputAdornment position='end'>
                            {insumosLoading
                                ? <CircularProgress color='inherit' size={20} />
                                : <SearchIcon className='search-icon' />}
                        </InputAdornment>
                    )
                }}
            />
        )}
    />
);

export default BuscadorInsumo;